/**
 * FixRuleLink — « Corriger la règle » : ouvre Paie › CCQ › Configuration sur la ligne fautive (?tab=config&rule=<id>). Batch #14.304.
 */
import { Link, useParams } from "react-router-dom";
import { Wrench } from "lucide-react";

export default function FixRuleLink({ ruleId, masterId, label = "Corriger la règle", testId, className = "" }) {
  const params = useParams();
  const mid = masterId || params.masterId;
  if (!ruleId || !mid) return null;
  return (
    <Link to={`/admin/paie/${mid}/ccq?tab=config&rule=${encodeURIComponent(ruleId)}`}
      className={`inline-flex items-center gap-1 rounded-md border border-rose-300 bg-white px-2 py-0.5 text-[10px] font-semibold text-rose-700 hover:bg-rose-100 transition whitespace-nowrap ${className}`}
      data-testid={testId || `paie-ccq-fix-rule-${ruleId}`}>
      <Wrench className="w-3 h-3" /> {label}
    </Link>
  );
}
